<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">
                        {{data.parcelNumber}} Parcel Reminder for {{data.name}} {{data.email ? ('(' + data.email + ')') : ''}}
                    </h4>
                </div>
                <div class="modal-body">
                    <div *ngIf="data.email">
                        <div class="form-group" id="summernote">{{message}}</div>
                    </div>

                    <h2 class="bold m-n text-center" *ngIf="!data.email && data.phone">
                        There is no email on resident's file<br/>
                        Please call {{data.name}} at {{data.phone}}
                    </h2>

                    <div class="row text-center m-b-lg m-t-md" *ngIf="!data.email && data.phone">
                        <button type="button" class="btn btn-primary submit-btn" (click)="hideModal()">Close</button>
                    </div>

                    <div class="row text-center m-b-lg m-t-md" *ngIf="data.email">
                        <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Send</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/parcels/parcel-reminder-modal/parcel-reminder-modal.component.html